import * as React from 'react';
import Comment from './sub/comment';
import Link from './sub/link';
import MainMedia from './sub/main-media';
import { NativeAdObj, Vertical } from '../../shared/types/ast';
import Logo from './sub/logo';
import Title from './sub/title';
import Description from './sub/description';
import TransparencyButton from './sub/transparencyButton';

type Props = {
    adObj: NativeAdObj;
    grid?: boolean;
    isBap?: boolean;
    vertical?: Vertical;
};

const NewConstruction = ({
    adObj,
    adObj: { native },
    grid,
    isBap,
    vertical,
}: Props) => {
    const bap = isBap || vertical === 'bap';
    return (
        <React.Fragment>
            <Comment placement="NewConstruction" adObj={adObj} />
            <div aria-owns={`result-item-heading-${adObj.targetId}`} />
            <div className="ads__unit__img">
                <div className="ads__unit__img__ratio img-format img-format--ratio3by2 img-format--crop-horizontal img-format--centered">
                    <MainMedia native={native} className="img-format__img" />
                </div>
            </div>
            <div className="ads__unit__content">
                <h2
                    className="ads__unit__content__title"
                    id={`result-item-heading-${adObj.targetId}`}
                >
                    <Link adObj={adObj} className="ads__unit__link">
                        <Title native={native} />
                    </Link>
                </h2>
                <div className="ads__unit__content__status u-position-relative">
                    <span className="status status--sponsored u-mb8">
                        Kommer for salg
                    </span>
                    {!bap && (
                        <div className="u-position-absolute u-top u-right">
                            <div className="button button--has-icon button--pill icon">
                                <TransparencyButton
                                    adObj={adObj}
                                    style={{
                                        position: 'relative',
                                        right: '31px',
                                        bottom: '15px',
                                        filter: '',
                                        transform: 'scaleY(1.2) scaleX(1.2)',
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <p>
                    <Description
                        native={native}
                        className="u-float-left ads__unit__content__list"
                    />
                    <Logo
                        native={native}
                        className="u-float-right"
                        style={{ maxHeight: '40px', maxWidth: '75px' }}
                    />
                </p>
            </div>
            {bap && (
                <div className="ads__unit__tools">
                    <div className="button button--has-icon button--pill icon">
                        <TransparencyButton
                            adObj={adObj}
                            style={{
                                position: 'relative',
                                right: '31px',
                                bottom: '15px',
                                filter: grid ? 'brightness(0) invert(1)' : '',
                                transform: 'scaleY(1.2) scaleX(1.2)',
                            }}
                        />
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default NewConstruction;
